<template lang="pug">
  v-container.virtual-container(fluid)
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-row.pb-0.mb-0
      v-col.d-flex.justify-end.pb-0.mb-0(cols="12")
        v-btn.main-btn-gradient(small dark style="height: 48px;" :loading="loadingSaveVirtShop" :disabled="!location.lat || !location.lng || !txtAddress || loadingSubdomain || !validSubdomain || !subdomainVshop"  @click='saveVirtualShop()')
          v-icon(small) mdi-content-save
          | {{$t('shops.virtual_shop.save_virtual_shop')}}
    v-row.mt-0.pt-0
        v-col.pt-0(cols="12" xs="12" sm="12" md="6")
            v-card.rounded-card.elevation-5.px-5
                v-card-title.justify-center.main-title-primary Configuración
                v-row
                  //- Share
                  v-col.d-flex.justify-end(cols="12")
                    v-icon.mx-1(size="28") mdi-share-variant
                    ShareNetwork.mx-1(
                      v-if="virtualShop.subdomain"
                      v-for="network in networks"
                      :network="network.network"
                      :key="network.network"
                      :url="sharing.url"
                      :title="sharing.title"
                      :description="sharing.description"
                      :quote="sharing.quote"
                      :hashtags="sharing.hashtags"
                      style="text-decoration: none !important;"
                    )
                      v-icon(size="28" :color="network.color") {{network.icon}}
                  //- Switch
                  v-col.py-0(cols="6")
                    v-switch(v-model="virtualShopActive" :disabled="inventoryLength || !virtualShop.subdomain" @change="activeVirtualShop($event)" :label='`${virtualShopActive ? "Desactivar tienda virtual" : "Activar tienda virtual"}`')
                    small(v-if="inventoryLength" color="") Esta tienda debe tener al menos un producto para activar la tienda virtual
                  //- Go Store
                  v-col.py-0.d-flex.justify-end.align-center(cols="6")
                    v-btn.main-btn-gradient(:disabled="!virtualShopActive || !virtualShop.subdomain" small dark :href="`https://tenderstore.shop/${virtualShop.subdomain}`" target="_blank")
                      v-icon(color="white") mdi-share
                      | Visitar tienda
                  //- subdomain
                v-row
                  v-col.py-0(cols="12" xs="8" sm="8" md="8" style="position: relative;")
                    .d-flex.align-center
                      p tenderstore.shop/
                      v-text-field.ml-2(:label="virtualShop.subdomain ? 'Nombre de tu tienda virtual' :'Nombre de tu tienda virtual'" :rules="[rules.required, rules.subdomain]" :disabled="!!virtualShop.subdomain" v-model="subdomainVshop")
                    //- Erros
                    span.red--text.validation-message(v-if="!virtualShop.subdomain && !validSubdomain && !loadingSubdomain && subdomainVshop && visibleText") Nombre no disponible. Por favor escoge otro.
                    span.green--text.validation-message(v-if="!virtualShop.subdomain && validSubdomain && !loadingSubdomain && subdomainVshop && visibleText") Nombre disponible
                  v-col.py-0.d-flex.justify-end.align-center(cols="12" xs="4" sm="4" md="4")
                    v-btn.main-btn-gradient(dark small v-if="!virtualShop.subdomain" @click="verifySubdomain" :disabled="!subdomainVshop || !validateSubdomains" :loading="loadingSubdomain")
                      | Validar nombre
                v-row
                  //- Directions
                  v-col.py-0(cols='12')
                    label.mr-1(v-if="location.lat && location.lng") Dirección:
                    label(v-if="location.lat && location.lng") {{txtAddress}}
                  //- Maps
                  v-col(cols="12")
                    gmap-autocomplete.location-input(@place_changed="setPlace" :options="autocompleteOptions" class="border-location" placeholder="Introduce la dirección de la tienda")
                    span(v-if="!location.lat || !location.lng" style="color: red;") No tienes una dirección guardada por favor ingresa una.
                    gmap-map(:center="center" :zoom="zoom" style="width:100%;  height: 300px;" :options="option").mt-4
                      gmap-marker(:key="index" v-for="(m, index) in markers" :animation="2" :position="m.position" :clickable="true" @click="openInfoWindow(m)")
                      gmap-info-window(:options="infoOptions" :position="infoContent.position" :opened="infoWinOpen" @closeclick="infoWinOpen=false")
        v-col.pt-0(cols="12" xs="12" sm="12" md="6")
          ShopCMS(:shopForm="shopForm" :rangeShop="rangeShop" :virtualShop="virtualShop")
</template>

<script>
  import imageCompression from 'browser-image-compression'
  import * as firebase from 'firebase'
  var geocoding = require('reverse-geocoding-google')
  var googleKey = 'AIzaSyDKCNiiLsmKRGo9E6UueE9sdZZArHJMJRU' // 'AIzaSyBS6_4xgnglXNo-pxeAJfmgOoGl3ZgdqGo'

  export default {
    components: {
      ShopCMS: () => import('@/views/custom/shops-content/ShopCMS'),
    },
    props: {
      shop: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        banActiveVirtualShop: false,
        validSubdomain: false,
        virtualShopActive: true,
        virtualShopsRestriction: null,
        validatorRestrictionsStatus: false,
        loadingSubdomain: false,
        visibleText: false,
        loadingSaveVirtShop: false,
        virtualShop: {
          id: '',
          name: '',
          address: '',
          addressgoogle: '',
          location: '',
          uid: '',
          img: '',
          categories: '',
          type: '',
          scope: '',
          mainCategorie: '',
          banner: '',
          colors: {
            primary: '#008e95FF',
            secondary: '#008e95FF',
          },
        },
        subdomainVshop: '',
        txtAddress: '',
        rangeShop: 0,
        rangeShopDefine: 0,
        location: {
          lat: '',
          lng: '',
        },
        center: { lat: 37.0902405, lng: -95.7128906 },
        markers: [],
        zoom: 16,
        option: {
          zoomControl: true,
          mapTypeControl: true,
          scaleControl: true,
          streetViewControl: true,
          rotateControl: true,
          fullscreenControl: true,
          disableDefaultUi: true,
        },
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
        },
        infoContent: {
          position: '',
          data: {
            location: '',
          },
        },
        infoWinOpen: false,
        shopMode: {
          marketplace: true,
          app: false,
        },
        shopForm: {
          description: '',
          domicileValue: 0,
          minOrderValue: 0,
        },
        rules: {
          required: value => !!value || 'Ingrese un nombre.',
          subdomain: value => {
            const pattern = /^[a-zA-Z]+$/
            return pattern.test(value) || 'Nombre invalido'
          },
        },
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
      }
    },
    computed: {
      inventoryLength () {
        if (!this.isLoadingData) {
          const temp = this.$store.getters['products/getAllItems']
            .filter(item => !!(item.location && item.location[this.shop.id]) && item.type !== 'ingredient') || []
          if (temp.length === 0) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      virtualShopSize () {
        return this.$store.state.shops.virtualShops.length
      },
      networks () {
        return [
          { network: 'facebook', name: 'Facebook', icon: 'mdi-facebook', color: '#1877f2' },
          { network: 'whatsapp', name: 'Whatsapp', icon: 'mdi-whatsapp', color: '#128c7e' },
        ]
      },
      sharing () {
        return {
          url: `http://tenderstore.shop/${this.virtualShop.subdomain}`,
          title: this.shop.name,
          description: this.shop.description,
          quote: 'Visita la tienda virtual',
          hashtags: 'tendershop',
        }
      },
      autocompleteOptions () {
        const country = this.$store.state.users.profile.direction && this.$store.state.users.profile.direction.country === 'México' ? 'mx' : 'co'
        return {
          componentRestrictions: {
            country: [
              country,
            ],
          },
        }
      },
      validateSubdomains () {
        const vm = this
        return /^[a-zA-Z]+$/.test(vm.subdomainVshop)
      },
    },
    watch: {
      virtualShopActive (val) {
        if (val) {
          this.rangeShop = this.rangeShopDefine
        } else {
          this.rangeShop = 0
        }
      },
    },
    mounted () {
      if (this.shop && this.shop.id) this.setDataShop(this.shop)
    },
    methods: {
      setDataShop (shop) {
        const vm = this
        try {
          let shopId = shop.id || null
          if (!shopId) { shopId = vm.$route.params.id }
          vm.$store.dispatch('shops/getVitualShop', shopId).then((res) => {
            if (res.length > 0) {
              if (res[0].data.status === 'active') {
                vm.virtualShopActive = true
              } else {
                vm.virtualShopActive = false
              }
              vm.virtualShop = res[0].data
              if (!vm.virtualShop.colors) {
                vm.virtualShop.colors = {
                  primary: '#008e95FF',
                  secondary: '#008e95FF',
                }
              }
              this.subdomainVshop = res[0].data.subdomain || ''
              this.validSubdomain = !!res[0].data.subdomain
              this.txtAddress = res[0].data.addressgoogle
              this.rangeShop = res[0].data.scope
              this.rangeShopDefine = res[0].data.scope
              // form shop
              this.shopForm = {
                description: res[0].data.description,
                domicileValue: res[0].data.domicileValue,
                minOrderValue: res[0].data.minOrderValue,
              }
              const place = {
                geometry: {
                  location: res[0].data.location,
                },
              }
              this.setPlaceVirtualShop(place)
            } else {
              this.virtualShopActive = false
              this.subdomainVshop = ''
              this.validSubdomain = false
            }
          })
          if (shop.status) {
            if (shop.status.val !== 'active') {
              this.banShopStatus = true
            }
          }
        } catch (err) {
          // console.log(err)
        }
      },
      activeVirtualShop (event) {
        const vm = this
        if (event) {
          vm.$store.dispatch('users/getRestrictions').then(res => {
            // console.log(res)
            if (res) {
              vm.virtualShopsRestriction = res.restrictions.virtualShops
              vm.status = res.status.val
              if (vm.status !== 'active') {
                vm.validatorRestrictionsStatus = true
                vm.banActiveVirtualShop = true
              }
              if (vm.virtualShopsRestriction === null) {
                vm.validatorRestrictions = true
                vm.banActiveVirtualShop = true
              }
              /* if (vm.virtualShopsRestriction <= vm.virtualShopSize) {
                        vm.validatorRestrictions = true
                        vm.banActiveVirtualShop = true
                    } */
            } else {
              vm.validatorRestrictions = true
              vm.banActiveVirtualShop = true
              vm.virtualShopActive = false
            }
          }, rej => {
            vm.setDataNotification(true, 'error', vm.$t('shop.createModule.errorGetRestriction'))
          })
        }
      },
      verifySubdomain () {
        this.validSubdomain = false
        this.loadingSubdomain = true
        this.visibleText = false
        const regexsubdomain = /^[a-zA-Z]+$/.test(this.subdomainVshop)
        if (regexsubdomain) {
          // console.log('dsfdsf')
          this.$store.dispatch('shops/validSubdomain', this.subdomainVshop).then(res => {
            this.loadingSubdomain = false
            // console.log('sdfdsf')
            if (res === 'ocupado') {
              this.validSubdomain = false
            } else if (res === 'libre') {
              this.validSubdomain = true
            }
            this.visibleText = true
          })
        } else {
          this.loadingSubdomain = true
          this.validSubdomain = false
          this.visibleText = true
        }
      },
      setPlace (place) {
        // console.log(place)
        const vm = this
        this.txtAddress = place.formatted_address
        vm.location = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        }
        vm.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        }
        this.markers = []
        this.markers.push({ position: vm.center })
      },
      setPlaceVirtualShop (place) {
        // console.log(place)
        const vm = this
        vm.location = {
          lat: place.geometry.location.lat,
          lng: place.geometry.location.lng,
        }
        vm.center = {
          lat: place.geometry.location.lat,
          lng: place.geometry.location.lng,
        }
        this.markers = []
        this.markers.push({ position: vm.center })
      },
      geolocate () {
        const vm = this
        navigator.geolocation.getCurrentPosition(position => {
          vm.location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
          vm.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
          this.markers = []
          this.markers.push({ position: vm.center })
          // gmapApi.geocoder.geo
          const config = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            key: googleKey,
          }
          geocoding.location(config, (err, data) => {
            if (err) {
              // console.log(err)
            } else {
              // console.log(data)
              this.txtAddress = data.results[0].formatted_address
            }
          })
        })
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      async saveVirtualShop () {
        const vm = this
        vm.loadingSaveVirtShop = true
        if (typeof vm.virtualShop.banner === 'object') {
          await vm.handleImageUpload(vm.virtualShop.banner)
        }
        const sendShop = vm.shop
        let mainCategori = {}
        if (sendShop.mainCategorieSelect) {
          mainCategori = sendShop.mainCategorieSelect
        } else {
          mainCategori = {
            id: 'cat20',
            data: 'Otro',
          }
        }
        vm.virtualShop = {
          id: sendShop.id,
          name: sendShop.name,
          address: sendShop.address,
          addressgoogle: vm.txtAddress,
          location: vm.location,
          uid: null,
          img: sendShop.pictures ? sendShop.pictures : '',
          categories: sendShop.categories || [],
          type: vm.shopMode,
          status: vm.virtualShopActive ? 'active' : 'inactive',
          scope: vm.rangeShop,
          mainCategorie: mainCategori,
          subdomain: vm.subdomainVshop.toLowerCase(),
          banner: vm.virtualShop.banner,
          colors: { ...vm.virtualShop.colors },
          // topSales: vm.topSales,
          ...vm.shopForm,
        }
        vm.$store.dispatch('shops/createVirtualShop', vm.virtualShop).then(res => {
          if (res) {
            // console.log(res)
            vm.virtualShop.subdomain = vm.subdomainVshop
            vm.setDataNotification(true, 'success', vm.$t('payment.message.successProcess'))
            vm.loadingSaveVirtShop = false
          }
        }).catch((error) => {
          console.log(error)
          vm.loadingSaveVirtShop = false
        })
      },
      // - upload image
      async handleImageUpload (file) {
        const vm = this
        const options = {
          maxSizeMB: 0.5,
          useWebWorker: true,
          maxIteration: 15,
        }
        if (file.size / 1024 / 1024 < 0.5) {
          return await vm.uploadToServer(file)
        }
        const compressedFile = imageCompression(file, options)
        if (file.size > compressedFile.size) return await vm.uploadToServer(compressedFile)
        else return await vm.uploadToServer(file)
      },
      async uploadToServer (file) {
        const vm = this
        const storageRef = firebase.storage().ref()
        const metadata = {
          contentType: file.type,
          customMetadata: {
            targetType: file.type,
            targetId: vm.shop.id,
            targetName: vm.shop.name,
          },
        }
        await storageRef.child(`users/${vm.shop.ownerId}/shops/pictures/${vm.shop.id}/banner`).put(file, metadata).then(async function (snapshot) {
          await snapshot.ref.getDownloadURL().then(function (url) {
            vm.virtualShop.banner = url
          })
        }).catch(function (error) {
          throw error
        })
      },
    },
  }
</script>

<style lang="scss">
    .virtual-container{
      .validation-message{
        position: absolute;
        bottom: 0;
      }
      .location-input{
        height: 40px !important;
        width: 100% !important;
        border: 1px solid #a2a2a2 !important;
        border-radius: 24px !important;
        padding: 10px !important;
      }
      .rounded-card{
        border-radius: 20px;
        height: 500px !important;
        overflow-y: scroll;
        overflow-x: hidden;
        &__title{
          position: absolute;
          font-size: 15px;
          font-weight: bold;
        }
        overflow-y: scroll !important;
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
</style>
